
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tennis-rating-converter",
      function () {
        return require("private-next-pages/tennis-rating-converter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tennis-rating-converter"])
      });
    }
  